import React from 'react'
import PropTypes from 'prop-types'
import {withStyles, Typography} from 'material-ui'

const styles = theme => ({
  container: {
    position: 'relative',
  },
  title: {
    color: theme.palette.primary.main,
    fontSize: '1.5rem',
    fontWeight: 500,
    margin: '1rem 0',
  },
  anchor: {
    position: 'absolute',
    top: -121,
  },
})

const Title = ({classes, children, className, ...props}) => {
  return (
    <div className={classes.container}>
      <Typography
        id="step-title"
        component="h2"
        align="center"
        className={`${classes.title} ${className}`}
        {...props}
      >
        {children}
      </Typography>
      <div id="step-title-anchor" className={classes.anchor}/>
    </div>
  )
}

Title.propTypes = {
  children: PropTypes.string.isRequired,
}


export default withStyles(styles, {withTheme: true})(Title)



// WEBPACK FOOTER //
// ./src/sections/addCreditCard/components/title.jsx